import debounceEvent from '@redux-beacon/debounce-event';
import { createMiddleware } from 'redux-beacon';
import { GoogleTagManager } from 'middlewares/googleTagManager';
import { addMiddleware } from 'redux-dynamic-middlewares';
import GoogleAnalytics4EventType from 'enums/googleAnalytics4EventType';
import getGoogleAnalytics4Event from 'services/googleAnalytics4EventBuilder';
import { googleAnalytics4Event, googleAnalytics4Impression } from './actions';

/**
 * The eventsMap function is a mapping of Redux actions to GoogleAnalytics4 events.
 * It returns an array of GoogleAnalytics4 events, which are objects with the following shape:
 * {
 *   eventType: string, // The name of the event (e.g., 'track')
 *   fieldsObj: object, // An object containing all properties for this event type (e.g., {eventName})
 * }
 *
 * @param action Determine which event to return
 *
 * @return An array of events
 */
const eventsMap = action => {
  switch (action.type) {
    case googleAnalytics4Event.type: {
      const payload = action.payload;
      const event = debounceEvent(
        1000,
        getGoogleAnalytics4Event(GoogleAnalytics4EventType.Event, {
          eventName: payload.eventName,
          customProperties: payload.customProperties
        })
      );
      return event;
    }
    case googleAnalytics4Impression.type: {
      const payload = action.payload;
      const event = debounceEvent(
        1000,
        getGoogleAnalytics4Event(GoogleAnalytics4EventType.Impression, {
          eventName: payload.eventName,
          customProperties: payload.customProperties
        })
      );
      return event;
    }
    default:
      return [];
  }
};

const googleTagManager = new GoogleTagManager();

/* `const middleware = createMiddleware(eventsMap, GoogleTagManager);` is creating a middleware using
`redux-beacon` library. The `createMiddleware` function takes two arguments: `eventsMap` and
`googleTagManager`. `eventsMap` is a function that maps Redux actions to G4 events, and `googleTagManager` is an
instance of the `@redux-beacon` library. The middleware created by `createMiddleware` will
listen for Redux actions and send corresponding G4 events using the `googleTagManager` instance. */
const middleware = createMiddleware(eventsMap, googleTagManager.getTarget());

// registers the middleware in redux
/* `addMiddleware(middleware)` is registering the middleware created by `createMiddleware` in the Redux
store. This allows the middleware to listen for Redux actions and send corresponding G4 events
using the `googleTagManager` instance. */
addMiddleware(middleware);
